import { FC } from 'react';

import { Flex, FlexProps, useColorModeValue } from '@bonusly/design-system';

type PillTabProps = FlexProps & {
	isActive?: boolean;
};

export const PillTab: FC<PillTabProps> = ({ isActive, ...rest }) => {
	const activeBg = useColorModeValue('secondary.bg', 'white');
	const activeColor = useColorModeValue('text.onColor', 'gray.900');

	return (
		<Flex
			as="button"
			bg={isActive ? activeBg : 'transparent'}
			borderColor={isActive ? 'transparent' : 'border.default'}
			borderRadius="full"
			borderStyle="solid"
			borderWidth="1px"
			color={isActive ? activeColor : 'text.default'}
			flexBasis="auto"
			flexShrink={1}
			fontWeight="medium"
			justifyContent="center"
			px={3}
			py={2}
			role="link"
			transitionDuration="normal"
			transitionProperty="common"
			whiteSpace="nowrap"
			{...(isActive && {
				'data-active': true,
			})}
			_hover={isActive ? { bg: activeBg, color: activeColor } : { bg: 'secondary.bgAlpha', color: 'text.default' }}
			{...rest}
		/>
	);
};
